// assets/card-swatch-interactions.js
(function () {
  function findCardRoot(el) {
    return el.closest('[data-product-card]') || el.closest('.card-wrapper') || el.closest('.grid__item');
  }

  function setImg(img, data) {
    if (!img || !data) return;
    const { src, srcset, alt, width, height } = data;
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
    if (alt) img.setAttribute('alt', alt);
    if (width) img.setAttribute('width', width);
    if (height) img.setAttribute('height', height);
  }

  function updateCardToButton(card, btn) {
    if (!card || !btn) return;

    // Primary image (variant featured)
    const imgPrimary = card.querySelector('[data-card-primary-img]') || card.querySelector('.card__media img');
    setImg(imgPrimary, {
      src: btn.getAttribute('data-primary-src'),
      srcset: btn.getAttribute('data-primary-srcset'),
      alt: btn.getAttribute('data-primary-alt'),
      width: btn.getAttribute('data-primary-width'),
      height: btn.getAttribute('data-primary-height')
    });

    // Secondary image (from variant_gallery metafield; falls back to primary data)
    // Use variant_gallery (secondary) for hover image; fallback to primary if missing
const imgSecondary = card.querySelector('[data-card-secondary-img]');
if (imgSecondary) {
  setImg(imgSecondary, {
    src: btn.getAttribute('data-secondary-src') || btn.getAttribute('data-primary-src'),
    srcset: btn.getAttribute('data-secondary-srcset') || btn.getAttribute('data-primary-srcset'),
    alt: btn.getAttribute('data-secondary-alt') || btn.getAttribute('data-primary-alt'),
    width: btn.getAttribute('data-secondary-width') || btn.getAttribute('data-primary-width'),
    height: btn.getAttribute('data-secondary-height') || btn.getAttribute('data-primary-height'),
  });
}

    // Update links in the card to selected variant URL
    const variantUrl = btn.getAttribute('data-variant-url');
    if (variantUrl) {
      card.querySelectorAll('a[href*="/products/"]').forEach((a) => {
        if (!a.closest('.card-swatch-list')) a.setAttribute('href', variantUrl);
      });
      card.querySelectorAll('[data-product-url]').forEach((el) => el.setAttribute('data-product-url', variantUrl));
    }

    // Active state
    const list = btn.closest('.card-swatch-list');
    if (list) {
      list.querySelectorAll('.card-swatch-item.is-active').forEach((li) => li.classList.remove('is-active'));
      list.querySelectorAll('.card-swatch.is-active').forEach((s) => s.classList.remove('is-active'));
      list.querySelectorAll('.card-swatch-button[aria-pressed="true"]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
      btn.closest('.card-swatch-item')?.classList.add('is-active');
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    }
  }

  function onChoose(e) {
    const btn = e.target.closest('.card-swatch-button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    const card = findCardRoot(btn);
    updateCardToButton(card, btn);
  }

  document.addEventListener('click', onChoose);
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('.card-swatch-button')) onChoose(e);
  });
})();